import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Carousel = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  // Array of images with src and alt, extended to 8
  const galleryImages = [
    { src: "images/img1.jpeg", alt: "Gallery" },
    { src: "images/img5.jpeg", alt: "Gallery" },
    { src: "images/img4.jpeg", alt: "Gallery" },
    { src: "images/img3.webp", alt: "Gallery" },
    { src: "images/img7.webp", alt: "Gallery" },
    { src: "images/img16.webp", alt: "Gallery" },
  ];

  return (
    <section className="section shadow-sm lazyloaded" id="Gallery">
      <span className="section-link"></span>{" "}
      <div className="row">
        <div className="col-md-8">
          <h2 className="head text-capitalize">{project} - Gallery</h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale float-lg-right mx-sm-auto  d-none d-lg-block"
            onClick={() => handleShowModal("Download Gallery")}
          >
            Download Gallery
          </button>
        </div>
      </div>
      <div className="owl-carousel-img owl-carousel owl-theme gallery-img">
        {galleryImages.map((image, index) => (
          // the div below will have className="at-property-item" for blur
          <div key={index} className="at-property-item">
            <a
              data-fancybox="gallery-0"
              onClick={() => handleShowModal("Download Gallery")}
              className="at-property-img"
            >
              <img
                data-src={`../${image.src}`}
                loading="lazy"
                className="gallery-thumb ls-is-cached lazyloaded"
                src={image.src}
                alt={image.alt}
              />
              <div className="at-property-overlayer"></div>
              <span
                className="btn btn-default at-property-btn"
                role="button"
                onClick={() => handleShowModal("Download Gallery")}
              >
                View Gallery
              </span>
            </a>
          </div>
        ))}
      </div>
      <div className="col-12">
        <button
          className="chat-btn btn btn-info micro-form-btn enqModal effetGradient effectScale float-lg-right mx-sm-auto d-lg-none"
          data-form="lg"
          data-title="Download Gallery"
          data-btn="Send Now"
          data-enquiry="Download Gallery"
          data-redirect="floorplan"
          data-toggle="modal"
          data-target="#enqModal"
          onClick={() => handleShowModal("Download Gallery")}
        >
          Download Gallery
        </button>
      </div>
    </section>
  );
};

export default Carousel;
